<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="mb-0">
        <i class="fas fa-bell mr-2"></i>
        {{ showAcknowledged ? 'All Alerts' : 'Active Alerts' }}
      </h5>
      <b-form-checkbox v-model="showAcknowledged" switch @change="onToggle">
        Show acknowledged
      </b-form-checkbox>
    </div>

    <div v-if="loading" class="text-center py-5">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div v-else-if="alertSummaries.length" class="d-flex flex-wrap">
      <alert-card
        v-for="alert in alertSummaries"
        :alert="alert"
        class="mr-3 mb-3"
        :key="alert.id"
        @processed="refreshAlerts"
      />
    </div>

    <div v-else class="text-muted py-4">
      <i class="fas fa-check-circle mr-2 text-success"></i>
      {{ showAcknowledged ? 'No alerts found.' : 'No active alerts.' }}
    </div>
  </div>
</template>

<script>
import { ALERT_SUMMARY_QUERY, ALERT_SUMMARY_ALL_QUERY } from '@/constants/graphql'
import AlertCard from '@/components/AlertCard.vue'

export default {
  name: 'alerts',
  components: { AlertCard },
  data () {
    return {
      alertSummaries: [],
      loading: false,
      showAcknowledged: false
    }
  },
  methods: {
    onToggle () {
      this.refreshAlerts()
    },
    async refreshAlerts () {
      this.loading = true
      try {
        var query = this.showAcknowledged ? ALERT_SUMMARY_ALL_QUERY : ALERT_SUMMARY_QUERY
        var result = await this.$apollo.query({ query, fetchPolicy: 'network-only' })
        this.alertSummaries = result.data.alertSummaries || []
      } catch (e) {
        this.alertSummaries = []
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.refreshAlerts()
  }
}
</script>
